import { IZone } from './types';

export const WHOLE_NETWORK_MIN_ZONES = 3;

const areNeighbors = (a: IZone, b: IZone): boolean | null => {
	// No neighborIds → no connection defined.
	if (a.neighborIds === null || b.neighborIds === null) return null;
	return a.neighborIds.includes(b.id) || b.neighborIds.includes(a.id);
};

/**
 * Whether the selection covers the whole network (MC-11538):
 * - 3+ selected zones → whole network;
 * - 2 selected zones that are not neighbours → whole network.
 * – Without a connection graph (`neighborIds: null`) two zones stay independent;
 * - 2 selected zones that are neighbors or 1 zone → only the selected zones.
 */
export const isWholeNetworkSelection = (
	zones: IZone[],
	selectedZoneIds: string[]
): boolean => {
	if (selectedZoneIds.length >= WHOLE_NETWORK_MIN_ZONES) return true;
	if (selectedZoneIds.length !== 2) return false;

	const [a, b] = selectedZoneIds.map((id) => zones.find((z) => z.id === id));
	if (!a || !b) return false;

	return areNeighbors(a, b) === false;
};
